/*
  assets/customer-service-topic.js
  ---------------------------------------------------------------------------
  A pedido: clickear una pregunta de vista previa en una tarjeta "Help
  topic" abre el modal de esa categoría (data-action="open-modal", nativo,
  sin tocar) YA con esa pregunta puntual expandida — en vez de solo
  mostrar la lista completa colapsada (eso sigue siendo lo que hace el
  botón "See all", que no lleva data-faq-question-id).

  Reusa el evento "collapsible:toggle" que theme.js ya escucha de forma
  genérica (_toggleCollapsible) para abrir/cerrar cualquier colapsable del
  tema — no hace falta reimplementar el expand/collapse acá, solo
  dispararlo para el id correcto una vez que el modal ya es visible.
*/
(function () {
  'use strict';

  document.querySelectorAll('[data-faq-question-id]').forEach(function (btn) {
    var questionId = btn.getAttribute('data-faq-question-id');
    if (!questionId) return;

    btn.addEventListener('click', function () {
      var toggle = document.querySelector('[aria-controls="block-' + questionId + '"][data-action="toggle-collapsible"]');
      if (!toggle) return;

      // El modal recién se está abriendo (misma acción data-action=
      // "open-modal" en este mismo click) — se espera un instante a que
      // termine de hacerse visible antes de medir/expandir y hacer
      // scroll, si no el cálculo de altura del colapsable puede salir mal.
      setTimeout(function () {
        if (toggle.getAttribute('aria-expanded') !== 'true') {
          document.dispatchEvent(new CustomEvent('collapsible:toggle', {
            detail: { id: toggle.getAttribute('aria-controls') }
          }));
        }
        toggle.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }, 80);
    });
  });
})();
